var map = {
	"./decidim/avatar-multiuser.png": 1825,
	"./decidim/brands/google.svg": 1040,
	"./decidim/cc-badge.png": 2835,
	"./decidim/decidim-logo.svg": 4393,
	"./decidim/default-avatar.svg": 4413,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 8376,
	"./decidim/icons.svg": 6746,
	"./decidim/pattern.png": 6115,
	"./decidim/placeholder-card-g.svg": 9282,
	"./decidim/placeholder-card-l.svg": 3403,
	"./decidim/placeholder.jpg": 3017,
	"./decidim/remixicon.symbol.svg": 4645,
	"./decidim/vendor/leaflet/layers-2x.png": 5734,
	"./decidim/vendor/leaflet/layers.png": 9996,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 4925,
	"./decidim/vendor/leaflet/marker-icon.png": 590,
	"./decidim/vendor/leaflet/marker-shadow.png": 2772,
	"./decidim/vendor/social-share-button/douban.svg": 8086,
	"./decidim/vendor/social-share-button/email.svg": 9649,
	"./decidim/vendor/social-share-button/facebook.svg": 2804,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 3566,
	"./decidim/vendor/social-share-button/hacker_news.svg": 9964,
	"./decidim/vendor/social-share-button/linkedin.svg": 1926,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 6681,
	"./decidim/vendor/social-share-button/pinterest.svg": 6786,
	"./decidim/vendor/social-share-button/reddit.svg": 1176,
	"./decidim/vendor/social-share-button/telegram.svg": 2582,
	"./decidim/vendor/social-share-button/tumblr.svg": 9968,
	"./decidim/vendor/social-share-button/twitter.svg": 3289,
	"./decidim/vendor/social-share-button/vkontakte.svg": 3140,
	"./decidim/vendor/social-share-button/wechat.svg": 523,
	"./decidim/vendor/social-share-button/whatsapp.svg": 601,
	"./decidim/vendor/social-share-button/x.svg": 9886,
	"./decidim/vendor/social-share-button/xing.svg": 5121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 954;